/*
 * @Author: RYL
 * @Description: 
 * @Date: 2020-11-23 16:17:33
 * @LastEditTime: 2022-03-31 13:36:21
 */
import { getCustomerList, getUserList } from "@/api/groupinglist";
import { getuser_iscustomer, getuser_ctid, getuser_id } from "@/localStorage/localStorage";
import { getFirstGroup, queryGroup } from '@/api/cloudMonitor/projectGroup'
import i18n from "../common/lang";
export const addProject = {
  data() {
    return {
      editData: {
        groupId: '',
        groupName: '',
        groupPid: '',
        groupCtid: '',
        groupLevel: 1,
        groupMonitorType: '0',
      },
      user_iscustomer: getuser_iscustomer(),
      user_ctid: getuser_ctid(),
      userId: getuser_id(),
      UserList: [],
      Customer: [],
      projectList: [],
      rules: {
        groupName: [
          { required: true, message: i18n.t('lang.FastAccess.pleaseName'), trigger: 'blur' }
        ],
        groupCtid: [
          {
            required: true, message: i18n.t('lang.FastAccess.pleasecustomer'), trigger: 'blur'
          }
        ],
        uid: [
          { required: true, message: i18n.t('lang.FastAccess.pleasecustomer'), trigger: 'blur' }
        ]
        // groupMonitorType: [
        //   { required: true, message: '请选择项目类型', trigger: 'blur' }
        // ],
        // groupLevel1: [
        //   { required: true, message: '请选择一级分组', trigger: 'blur' }
        // ]
      },
    }
  },
  methods: {
    clearData() {
      this.editData = {
        groupId: '',
        groupName: '',
        groupPid: '',
        groupCtid: '',
        groupLevel: 1,
        groupMonitorType: '0',
      }
    },
    // 获取客户
    getCustomer() {
      //获取客户列表
      getCustomerList().then(res => {
        this.Customer = res.data.data.list;
      });
    },
    getUser() {
      getUserList().then(res => {
        this.UserList = res.data.data.list;
      });
    },
    // 获取一级列表
    getFirstList() {
      let params = {
        current: 1,
        size: 99999
      }
      queryGroup(params).then(res => {
        if (res.data.code === 0) {
          let data = res.data.data
          this.projectList = data.records
          this.total = data.total
        }
      }).catch(() => {
      })
      // getFirstGroup(params).then(res => {
      //   if(res.data.code === 0) {
      //     let data = res.data.data
      //     this.projectList = data.records
      //     this.total = data.total
      //   }
      // }).catch(() => {
      // })
    },
  }
}